import dayjs from "dayjs";

export const formatoFechaExportacion = (time) => {


    let date = new Date(time)



    let texto = dayjs(date).format('DD/MM/YYYY hh:mm:ss')

    return texto

}